<template>
  <div v-loading.body="loading">
    <div class="c_page-title">
      <div>点货单列表</div>
      <el-button
        class="icon-fresh"
        size="mini"
        icon="el-icon-refresh"
        @click="fetchData(true)"
        >刷新</el-button
      >
    </div>
    <el-row class="filter">
      <el-col>
        <div
          style="
            background: #f3f3f3;
            height: 30px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
            align-items: center;
          "
        >
          <div>查询搜索</div>
          <el-button
            type="text"
            style="margin-left: auto"
            :icon="filterFold ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"
            @click="toggleFilter"
          >
            {{ filterFold ? "展开筛选" : "收起筛选" }}
          </el-button>
        </div>
        <el-collapse-transition>
          <div v-show="!filterFold">
            <div style="padding: 10px 25px">
              <el-form :inline="true" :model="form" class="demo-form-inline">
                <el-form-item label="输入搜索：">
                  <el-input
                    v-model="form.supply_name"
                    placeholder="商家"
                    @keyup.native.enter="search"
                  ></el-input>
                </el-form-item>
                <el-form-item v-if="selectPgid">
                  <el-select
                    v-model="form.pgid"
                    placeholder="选择代采组"
                    filterable
                    multiple
                  >
                    <el-option
                      v-for="item in selectPgid"
                      :key="item.key"
                      :label="item.pgname"
                      :value="item.pgid"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item v-if="selectType">
                  <el-select v-model="form.type" placeholder="选择类型">
                    <el-option label="全部" value=""></el-option>
                    <el-option
                      v-for="item in selectType"
                      :key="item.key"
                      :label="item.label"
                      :value="item.key"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item v-if="selectStatus">
                  <el-select v-model="form.create_type" placeholder="创建方式">
                    <el-option label="全部" value=""></el-option>
                    <el-option
                      v-for="item in create_type"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item v-if="selectStatus">
                  <el-select v-model="form.status" placeholder="选择状态">
                    <el-option label="全部" value=""></el-option>
                    <el-option
                      v-for="item in selectStatus"
                      :key="item.key"
                      :label="item.label"
                      :value="item.key"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="">
                  <el-input
                    v-model="form.package_no"
                    placeholder="包裹号"
                    @keyup.native.enter="search"
                  ></el-input>
                </el-form-item>
                <el-form-item>
                  <el-input
                    v-model="form.pici_no"
                    placeholder="批次号"
                    @keyup.native.enter="search"
                  ></el-input>
                </el-form-item>
                <el-select
                  v-model="form.origin"
                  label="仓库"
                  style="width: 150px"
                  placeholder="选择仓库"
                >
                  <el-option
                    v-for="item in storehouseIds"
                    :key="item.key"
                    :value="item.key"
                    :label="item.label"
                  >
                  </el-option>
                </el-select>
                <el-form-item>
                  <el-select v-model="form.in_type" placeholder="入库方式">
                    <el-option
                      v-for="item in in_type"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item v-if="selectStatus">
                  <el-select v-model="form.is_diff" placeholder="是否有差异">
                    <el-option label="全部" value=""></el-option>
                    <el-option
                      v-for="item in is_diff"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-input
                    v-model="form.pici_id"
                    placeholder="点货ID"
                    @keyup.native.enter="search"
                  ></el-input>
                </el-form-item>
              </el-form>
            </div>
            <div style="padding: 0 25px">
              <el-form :inline="true" :model="form" class="demo-form-inline">
                <el-form-item label="开始时间：">
                  <el-date-picker
                    v-model="form.create_time"
                    :default-time="['06:00:00', '06:00:00']"
                    type="datetimerange"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                  >
                  </el-date-picker>
                </el-form-item>
              </el-form>
            </div>
            <div style="padding: 0 25px">
              <el-form :inline="true" :model="form" class="demo-form-inline">
                <el-form-item label="提交时间：">
                  <el-date-picker
                    v-model="form.commit_time"
                    :default-time="['06:00:00', '06:00:00']"
                    type="datetimerange"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                  >
                  </el-date-picker>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="search">查询</el-button>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </el-collapse-transition>
      </el-col>
    </el-row>

    <el-row>
      <el-col style="border: 1px solid #ddd">
        <div
          style="
            background: #f3f3f3;
            height: 50px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
            align-items: center;
          "
        >
          <div>数据列表：</div>
          <el-button
            style="margin-left: auto"
            type="success"
            size="mini"
            @click="output"
            >导出</el-button
          >
        </div>
        <div style="margin-bottom: 0">
          <el-table
            v-if="resData"
            ref="multipleTable"
            v-loading="tableLoading"
            height="600"
            :data="resData.data"
            tooltip-effect="dark"
            style="width: 100%"
            @selection-change="handleSelectionChange"
          >
            <!-- <el-table-column align="center" type="selection" width="55">
                        </el-table-column> -->
            <el-table-column
              align="center"
              prop="pici_id"
              label="点货ID"
              width="120"
            >
            </el-table-column>
            <el-table-column
              align="center"
              prop="desk_no"
              label="工作台"
              width="120"
            >
            </el-table-column>
            <el-table-column
              align="center"
              prop="box_no"
              label="容器号"
              width="120"
            >
            </el-table-column>
            <el-table-column
              align="center"
              prop="origin_txt"
              label="仓库"
              width="120"
            >
            </el-table-column>
            <el-table-column align="center" prop="supply_name" label="商家">
            </el-table-column>
            <el-table-column
              prop="pgname"
              label="代采组"
              show-overflow-tooltip
              align="center"
              width="100"
            >
            </el-table-column>
            <el-table-column prop="package_no" label="包裹号" align="center">
              <template #default="scope">
                <a
                  :href="'#/home/supply/package-list?pici=' + scope.row.pici_no"
                  target="_blank"
                  class="buttonText"
                  >{{ scope.row.package_no }}</a
                >
              </template>
            </el-table-column>
            <el-table-column
              prop="package_create_time"
              label="包裹生成时间"
              align="center"
            />
            <el-table-column prop="pici_no" label="批次号" align="center">
            </el-table-column>
            <el-table-column
              prop="create_type"
              label="创建方式"
              show-overflow-tooltip
              align="center"
              width="100"
            >
            </el-table-column>
            <el-table-column
              prop="type_txt"
              label="类型"
              show-overflow-tooltip
              align="center"
              width="100"
            >
            </el-table-column>
            <el-table-column
              prop="goods_eff_num"
              label="常规打标"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="goods_inv"
              label="不良品标"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="no_data_num"
              label="无数据标"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="no_data_goods_num"
              label="其中无数据标"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="chayi_remark"
              label="差异备注"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="status_txt"
              label="状态"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="storage_pici_in_type"
              label="入库方式"
              show-overflow-tooltip
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="admin_name"
              label="提交人"
              sortable
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="create_time"
              label="开始时间"
              width="100"
              sortable
              align="center"
            ></el-table-column>
            <el-table-column
              prop="commit_time"
              label="提交时间"
              width="100"
              sortable
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="confirm_admin"
              label="审核人"
              sortable
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="confirm_time"
              label="审核时间"
              width="100"
              sortable
              align="center"
            >
            </el-table-column>
            <el-table-column label="点货视频">
              <template #default="scope">
                <el-button size="small" @click="showVideo(scope.row)">
                  查看</el-button
                >
              </template>
            </el-table-column>
            <el-table-column
              label="操作"
              show-overflow-tooltip
              align="center"
              width="200"
            >
              <template #default="scope">
                <el-button
                  v-if="scope.row.pici_status != 15"
                  type="text"
                  size="small"
                  @click="handleDetail(scope.row)"
                  >查看
                </el-button>
                <el-button
                  v-if="scope.row.pici_status == 0"
                  type="text"
                  size="small"
                  @click="handleDelete(scope.row)"
                  >删除
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div v-if="resData" style="text-align: right; padding: 25px">
          <el-pagination
            :current-page.sync="curPage"
            background
            layout="total, prev, pager, next, jumper "
            :total="resData.total"
            :page-size="10"
            @current-change="handleCurrentChange"
          >
          </el-pagination>
        </div>
      </el-col>
    </el-row>
    <el-dialog
      :before-close="handleVideoClose"
      :visible.sync="showPiciVideo"
      title="点货视频"
      width="50%"
    >
      <el-table v-if="piciVideoListShow" :data="piciVideoList">
        <el-table-column label="文件" width="400">
          <template #default="scope">
            <span>\\{{ piciVideoIp }}\录像\{{ scope.row.filename }}</span>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleVideoClose">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import apiBaseURL from "@/utils/baseUrl.js";

export default {
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.fetchData();
    });
  },
  data() {
    return {
      showPiciVideo: false,
      piciVideoPlayShow: false,
      piciVideoListShow: false,
      piciVideoUrl: null,
      piciVideoList: null,
      piciVideoIp: "",
      showVideoPiciId: 0,
      resData: null,
      form: {
        create_time: [],
        commit_time: [],
        in_type: [],
      },
      in_type: [
        {
          value: 1,
          label: "批次入库",
        },
        {
          value: 2,
          label: "扫码入库",
        },
        {
          value: 3,
          label: "分播入库",
        },
        {
          value: 4,
          label: "PDA入库",
        },
        {
          value: 5,
          label: "容器提交入库",
        },
      ],
      is_diff: [
        {
          value: 1,
          label: "是",
        },
        {
          value: 0,
          label: "否",
        },
      ],
      create_type: [
        {
          value: 2,
          label: "无数据创建",
        },
        {
          value: 1,
          label: "包裹号创建",
        },
        {
          value: 0,
          label: "手动创建",
        },
      ],
      loading: false,
      tableLoading: false,
      url: "/erp/pici/getlist",
      status: -1,
      curPage: 1,
      filterFold: false,
      selectPgid: [],
      selectType: [],
      selectStatus: [],
      multipleSelection: [],
      originOptions: [
        {
          value: "1",
          label: "广州",
        },
        {
          value: "2",
          label: "杭州",
        },
      ],
      storehouseIds: [],
    };
  },
  computed: {
    filteredForm() {
      for (const key in this.form) {
        if (
          this.form[key] === undefined ||
          this.form[key] === "" ||
          this.form[key] === null
        ) {
          delete this.form[key];
        }
      }
      return this.form;
    },
    stringSelection() {
      const newArr = this.multipleSelection.map((item) => {
        return item.planid;
      });
      return newArr.join(",");
    },
  },
  created() {},
  mounted() {},
  methods: {
    output() {
      const url = "/erp/pici/export";
      const data = {
        create_time: this.form.create_time,
        pgid: this.form.pgid,
        pici_no: this.form.pici_no || "",
        status: this.form.status || "",
        supply_name: this.form.supply_name || "",
        type: this.form.type || "",
        origin: this.form.origin || 0,
        package_no: this.form.package_no || "",
        in_type: this.form.in_type,
      };
      // 删除空参数
      Object.keys(data).forEach((key) => data[key] == "" && delete data[key]);
      if (!this.form.create_time) {
        this.$message.error("请选择开始时间和结束时间");
        return;
      }
      this.$http.post(url, data).then((res) => {
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          window.open(apiBaseURL + res.data.data.file);
        }
      });
    },
    fetchData(showLoading) {
      this.$http
        .post("/erp/StockStorehouse/listStockStorehouseConfig")
        .then((res) => {
          if (res.data.code == 200) {
            this.storehouseIds = res.data.data;
          }
        });
      if (showLoading) {
        this.loading = true;
      }
      const pn = this.$route.query.package_no;
      if (pn) {
        this.filteredForm.package_no = pn;
      }
      this.$http.post(this.url, this.filteredForm).then((res) => {
        this.loading = false;
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
          // //开始结束日期生成
          // let dateObj = new Date();
          // let eyear = dateObj.getFullYear();
          // let emonth = (dateObj.getMonth());
          // let eday = dateObj.getDate();
          //
          // let startObj =  new Date(eyear,emonth,eday -7);
          // let syear = startObj.getFullYear();
          // let smonth = startObj.getMonth();
          // let sday = startObj.getDate();
          //
          // let endDate = eyear + '-' + emonth + '-' + eday;
          // let startDate = syear + '-' + smonth + '-' + sday;
          // this.form.create_time = [startDate, endDate];
        }
      });
      this.$http.post("/erp/Common/selectPgid", {}).then((res) => {
        if (res.data.code !== 200) {
          this.$message.e(res.data.msg);
        } else {
          this.selectPgid = res.data.data;
        }
      });
      this.$http.post("/erp/pici/getType", {}).then((res) => {
        if (res.data.code !== 200) {
          this.$message.e(res.data.msg);
        } else {
          this.selectType = res.data.data;
        }
      });
      this.$http.post("/erp/pici/getStatus", {}).then((res) => {
        if (res.data.code !== 200) {
          this.$message.e(res.data.msg);
        } else {
          this.selectStatus = res.data.data;
        }
      });
    },
    toggleFilter() {
      this.filterFold = !this.filterFold;
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    onSubmit() {},
    // 切换页码
    handleCurrentChange(val) {
      this.form.page = val;
      this.tableLoading = true;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        setTimeout(() => {
          this.tableLoading = false;
        }, 200);
        if (res.data.code !== 200) {
          this.$message.e(res.data.msg);
        } else {
          this.resData = res.data.data;
        }
      });
    },
    handleDetail(row) {
      this.$router.push(`/home/storage/tallyingdetail/${row.pici_id}`);
    },

    search() {
      this.form.page = 1;
      this.loading = true;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        setTimeout(() => {
          this.loading = false;
        }, 200);
        if (res.data.code !== 200) {
          this.$message.e(res.data.msg);
        } else {
          this.resData = res.data.data;
          (this.status = this.filteredForm.status), (this.curPage = 1);
        }
      });
    },
    showVideo(row) {
      this.$http
        .post("/erp/pici/getPiciVideo", {
          pici_id: row.pici_id,
        })
        .then((res) => {
          if (res.data.code == 200) {
            this.showPiciVideo = true;
            this.showVideoPiciId = row.pici_id;
            this.piciVideoListShow = true;
            this.piciVideoPlayShow = false;
            this.piciVideoUrl = null;
            this.piciVideoList = res.data.data.file_list;
            this.piciVideoIp = res.data.data.ip;
          } else {
            this.$message.e(res.data.msg);
          }
        });
    },
    playVideo(filename) {
      this.$http
        .post("/erp/pici/playVideo", {
          pici_id: this.showVideoPiciId,
          file: filename,
        })
        .then((res) => {
          if (res.data.code == 200) {
            this.piciVideoPlayShow = true;
            this.piciVideoListShow = false;
            this.piciVideoUrl = res.data.data;
          } else {
            this.$message.e(res.data.msg);
          }
        });
    },
    handleVideoClose() {
      this.showPiciVideo = false;
      this.showVideoPiciId = 0;
      this.piciVideoListShow = false;
      this.piciVideoPlayShow = false;
      this.piciVideoList = null;
      this.piciVideoUrl = null;
      this.piciVideoIp = null;
    },
    handleVideoListShow() {
      this.piciVideoListShow = true;
      this.piciVideoUrl = null;
      this.piciVideoPlayShow = false;
    },
    handleDelete(row) {
      this.$confirm("确定删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          const url = "/erp/pici/del";
          const data = {
            pici_id: row.pici_id,
          };
          this.$http.post(url, data).then((res) => {
            if (res.data.code !== 200) {
              this.$message.error(res.data.msg);
            } else {
              this.fetchData();
              this.$message({
                type: "success",
                message: "删除成功!",
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
  },
};
</script>

<style scoped>
.row {
  height: 60px;
}

.column {
  text-align: center;
  border: 1 px solid #ddd;
  font-size: 12px;
}

.data-statics {
  background: #f3f3f3;
  height: 40px;
  font-size: 14px;
  color: #333;
  line-height: 40px;
  padding: 0 25px;
}

.filter {
  border: 1px solid #ddd;
}

.el-row {
  margin-bottom: 20px;
}

.el-row:last-child {
  margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/Tallying.vue